/**
 * json-modal.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

export class GenericObjectContext extends BSModalContext
{
  public object : any;
  public note? : string;
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Debug JSON Structure
    </h4>
  </div>

  <div class="modal-body">
    <p *ngIf="note"><strong>Note:</strong> {{note}}</p>
    <prettyjson [obj]="object"></prettyjson>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      (click)="dialog.close()">
      OK
    </button>
  </div>
  `,
  styles: []
})
export class JsonModalComponent implements ModalComponent<GenericObjectContext>
{
  public object : any = "modal uninitialized";
  public note : string;

  constructor (public dialog : DialogRef<GenericObjectContext>)
  {
    if (typeof dialog.context.object !== "object")
    {
      console.error("Could not open JsonModalComponent: non-Object");
      dialog.dismiss();
    }
    else
    {
      this.object = dialog.context.object;
      this.note = dialog.context.note;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/debug/json-modal.component.ts